<template>
  <div id="testimonials">
    <div class="grid-container">
      <div class="w-row">
        <div class="w-col">
          <h1 id="title">
            <strong>{{ $t("marinConstantin.testimonials.title") }}</strong>
          </h1>
        </div>
      </div>
      <Loading v-if="!data" />
      <div class="w-layout-grid testimonial-grid" v-if="data">
        <div
          v-for="(item, index) in data"
          :key="item.key"
          :class="{
            image: index % 2 === 0,
            content: index % 2 === 1,
            'image-left': index % 4 === 0,
            'content-left': index % 4 === 3,
            'image-right': index % 4 === 2,
            'content-right': index % 4 === 1
          }"
          class="font-fira"
          v-bind:style="[
            index % 2 === 0
              ? { backgroundImage: 'url(' + item.thumbnail + ')' }
              : {}
          ]"
        >
          <p class="paragraph-5 " v-html="item.text" v-if="index % 2 === 1"></p>
          <div class="author" v-if="index % 2 === 1">{{ item.author }}</div>
          <div class="author-position" v-if="index % 2 === 1">
            {{ item.author_subtext }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../Loading";

export default {
  name: "MCTestimonials",
  components: { Loading },
  data() {
    return {
      data: null
    };
  },
  methods: {
    handleResponse(response) {
      this.data = [];
      for (let i = 0, n = response.data.length; i < n; i++) {
        let image = JSON.parse(JSON.stringify(response.data[i]));
        image.key = "image" + image.id;
        this.data.push(image);
        let text = response.data[i];
        // description.key = image.id;
        this.data.push(text);
      }
    }
  },
  mounted() {
    this.$http
      .get("marin-constantin/testimonial/")
      .then(response => this.handleResponse(response));
  }
};
</script>

<style scoped>
#testimonials {
  padding: 10vh 0;
  background-color: #f1f1f1;
}

#title {
  margin-bottom: 7vh;
  text-transform: uppercase;
  text-align: center;
  color: #19242c;
  font-size: 3.2em;
}

@media (max-width: 476px) {
  #title {
    font-size: 2em;
  }
}

.grid-container {
  width: 100%;
  margin: auto;
  max-width: 840px;
}

.testimonial-grid {
  padding: 0 10px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-auto-flow: column dense;
  grid-column-gap: 0;
  grid-row-gap: 50px;
}

.content-left {
  grid-column-start: 1;
  grid-column-end: 4;
  padding-right: 35px;
}

.content-right {
  grid-column-start: 2;
  grid-column-end: 5;
  padding-left: 35px;
}

.content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: #354e60;
  font-weight: 300;
  border-bottom: 1px solid #ddd;
}

.image {
  width: 100%;
  height: 100%;
  min-height: 200px;
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
}

.image-left {
  grid-column-start: 1;
  grid-column-end: 2;
}

.image-right {
  grid-column-start: 4;
  grid-column-end: 5;
}

@media (max-width: 476px) {
  .testimonial-grid {
    grid-row-gap: 15px;
  }

  .content-left {
    grid-column-start: 1;
    grid-column-end: 5;
    padding-right: 0;
  }

  .content-right {
    grid-column-start: 1;
    grid-column-end: 5;
    padding-left: 0;
  }

  .image-left {
    grid-column-start: 1;
    grid-column-end: 5;
  }

  .image-right {
    grid-column-start: 1;
    grid-column-end: 5;
  }
}

.paragraph-5 {
  font-size: 1.2em;
}

.author {
  color: #79685a;
  font-weight: 700;
  font-size: 1.2em;
}

.author-position {
  color: #79685a;
  font-size: 1.1em;
  font-weight: 300;
}
</style>
